import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import * as authenticationTypes from '../../types';
import { IMessage } from '../../../shared/types';

@Component({
  selector: 'tr-update-password',
  templateUrl: './update-password.component.html',
  //styleUrls: ['./update-password.component.scss']
})
export class UpdatePasswordComponent implements OnInit {
  updatePasswordForm: FormGroup;
  @Output() authenticate = new EventEmitter<authenticationTypes.IUpdatePassword>();
  @Output() cancel = new EventEmitter<string>();
  @Input() isBusy: boolean;
  @Input() message: IMessage;
  @Input() isNewUser: boolean;
  @Input() pattern: string;
  @Input() oldPassword: string = '';
  
  private hideCurrentPassword: boolean;
  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.message = null;
    this.hideCurrentPassword = this.isNewUser && this.oldPassword !== '';
    let currentPassword = new FormControl(this.oldPassword, Validators.required);
    let newPassword = new FormControl('', Validators.compose([
      Validators.required,
      Validators.pattern(this.pattern)
    ]));
    let newPasswordConfirm = new FormControl('', Validators.compose([
        Validators.required,
        CustomValidators.equalTo(newPassword)
      ])
    );

    let formGroup = {
      'currentPassword': currentPassword,
      'newPassword': newPassword,
      'newPasswordConfirm': newPasswordConfirm
    };

    this.updatePasswordForm = this.fb.group(formGroup);
  }

  onSubmit(): void {
    this.authenticate.emit(this.updatePasswordForm.value);
  }

  onCancel(): void {
    this.cancel.emit('cancel');
  }

}



// WEBPACK FOOTER //
// ./src/app/authentication/components/update-password/update-password.component.ts